/* import __COLOCATED_TEMPLATE__ from './clinician-select-redesign.hbs'; */
import { classNames } from '@ember-decorators/component';
import RequestClinicianSelect from './clinician-select';
import styles from './clinician-select-redesign.module.scss';

@classNames('clinician-select text-left justify-content-between', styles.component)
export default class RequestClinicianSelectRedesign extends RequestClinicianSelect {
  styles = styles;
}
